module.exports = __webpack_public_path__ + "img/11_20.957302c2.png";